var exports = {
  "h_": "DuplicateGroupConfirmModal.module__description___RHl1Tk",
  "o5": "DuplicateGroupConfirmModal.module__channelList___RHl1Tk",
  "fc": "DuplicateGroupConfirmModal.module__channelItem___RHl1Tk",
  "R3": "DuplicateGroupConfirmModal.module__avatarWrapper___RHl1Tk",
  "E8": "DuplicateGroupConfirmModal.module__channelDetails___RHl1Tk",
  "HA": "DuplicateGroupConfirmModal.module__channelName___RHl1Tk",
  "Rj": "DuplicateGroupConfirmModal.module__lastActive___RHl1Tk",
};

module.exports = exports;
